import React, { useState, useContext } from "react";
import jigsawml_logo from "../../../../../images/Jigsaw_logo.svg";
import "./Navbar.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CloseIcon from "../../../../../images/clear.svg";
import HamburgerIcon from "../../../../../images/menu.svg";
import Dropdown from "react-bootstrap/Dropdown";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import useFormHandler from "../../../../NewLanding2/useFormHandler";
import AccessModal from "../../../../NewLanding2/AccessModal";
import ThanksModal from "../../../../NewLanding2/ThanksModal";
import { ArrowBack } from "../../../../../images/svg/icons";
import ProfileDropdown from "../../../../../common/components/ProfileDropdown/ProfileDropdown";
import CreateContext, {
  ContextType,
} from "../../../../../store/create-context";
import { CALENDLY_TALK_TO_US_URL } from "../../../../../constants";
import DisabledWhileLoginOff from "../../../../../common/components/DisabledWhileLoginOff/DisabledWhileLoginOff";
import { LOGIN_ENABLED } from "../../../../../common/loginAvailability";

const ChevronUp = FaChevronUp as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;
const ChevronDown = FaChevronDown as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

interface NavbarProps {
  showbox?: boolean;
  logoutHandler?: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ logoutHandler }) => {
  const ctx = useContext(CreateContext);
  const ctxLogout = ctx?.logoutHandler;
  const resolvedLogout = logoutHandler ?? ctxLogout ?? (() => {});
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isProductDropdownOpen, setIsProductDropdownOpen] = useState(false);
  const [isSolutionsDropdownOpen, setIsSolutionsDropdownOpen] = useState(false);
  const [isPressDropdownOpen, setIsPressDropdownOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const fromPath = (location.state as { path?: string } | undefined)?.path;

  const handleProductToggle = (isOpen: boolean) => {
    setIsProductDropdownOpen(isOpen);
  };

  const handleSolutionsToggle = (isOpen: boolean) => {
    setIsSolutionsDropdownOpen(isOpen);
  };

  const handlePressToggle = (isOpen: boolean) => {
    setIsPressDropdownOpen(isOpen);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleBackClick = () => {
    const historyIndex = window.history.state?.idx ?? 0;

    if (historyIndex > 0 && !fromPath) {
      navigate(-1);
      return;
    }

    navigate("/");
  };

  const lastPathSegment = window.location.href.split("/").pop();
  const isDemoPage = lastPathSegment === "demo";
  const isLoginPage = lastPathSegment === "login";
  // const isChangePasswordPage = lastPathSegment === "change-password";
  // With login disabled there is no backend, so a stored token must not show "Dashboard" or the profile menu.
  const isLoggedIn = LOGIN_ENABLED && localStorage.getItem("JMLAuthToken");
  const loginOrDashboardButton = (
    <DisabledWhileLoginOff>
      <Link
        to={isLoggedIn ? "/dashboard" : "/login"}
        className="jigsaw_login_button"
      >
        {isLoggedIn ? "Dashboard" : "Login"}
      </Link>
    </DisabledWhileLoginOff>
  );

  // const routesForBeta = ["in-press","blog","sw-arch-visualizer"];
  //const allowBeta = routesForBeta.includes(window.location.href.split('/')[window.location.href.split('/').length-1]);
  // const allowBeta = true;

  const {
    email,
    name,
    affiliation,
    message,
    isValidEmail,
    emailError,
    showAccessModal,
    showThanksModal,
    isSubmitting,
    formRef,
    setEmailHandler,
    setNameHandler,
    setAffiliationHandler,
    setMessageHandler,
    formSubmitHandler,
    // setEmail,
    // setName,
    // setAffiliation,
    // setMessage,
    // setIsValidEmail,
    // setEmailError,
    setShowAccessModal,
    setShowThanksModal,
  } = useFormHandler();

  return (
    <nav
      className="jigsaw_navbar"
      // style={{ top: !showbox ? "0" : "3.4rem" }}
    >
      <div className="jigsaw_navbar_container">
        {/* Logo */}
        <div className="jigsaw_logo_container">
          <Link to="/">
            <img
              src={jigsawml_logo}
              alt="JigsawML Logo"
              className="jigsaw_logo"
              fetchPriority="high"
              decoding="async"
            />
          </Link>
        </div>

        {/* Hamburger Menu for Mobile */}
        {/* {!isChangePasswordPage && ( */}
        <div className="jigsaw_mobile_menu_icon" onClick={toggleMobileMenu}>
          {isMobileMenuOpen ? (
            <img
              src={CloseIcon}
              alt="CloseIcon"
              className="jigsaw_menu_icon"
              decoding="async"
            />
          ) : (
            <img
              src={HamburgerIcon}
              alt="HamburgerIcon"
              className="jigsaw_menu_icon"
              style={{
                filter:
                  "invert(100%) sepia(0%) saturate(7500%) hue-rotate(180deg) brightness(95%) contrast(101%)",
              }}
              decoding="async"
            />
          )}
        </div>
        {/* )} */}

        {/* Nav items in middle - Desktop */}
        {/* {!isChangePasswordPage && ( */}
        <div className="jigsaw_nav_items jigsaw_desktop_nav">
          <Link to={"/"} className="jigsaw_nav_item jigsaw_scanner">
            <span>Home</span>
          </Link>
          <Dropdown
            onToggle={handleProductToggle}
            className="jigsaw_nav_item jigsaw_scanner"
          >
            <Dropdown.Toggle
              style={{
                background: "transparent",
                border: "none",
                padding: "0",
                color: "#B1B1B1",
              }}
            >
              <span>
                <span style={{ marginRight: "5px" }}>Product</span>
                {isProductDropdownOpen ? (
                  <ChevronUp className="chevron-icon" />
                ) : (
                  <ChevronDown className="chevron-icon" />
                )}
              </span>
            </Dropdown.Toggle>

            <Dropdown.Menu
              style={{ border: "none", marginLeft: "40px" }}
              className="jigsaw_nav_item"
            >
              <Dropdown.Item as={Link} to="/product">
                <span style={{ marginRight: "5px" }}>
                  Architecture Generator
                </span>
                {/* <span className="jigsaw_beta_tag">Beta</span> */}
              </Dropdown.Item>
              <Dropdown.Item as={Link} to="/cloud-scanner">
                <span style={{ marginRight: "5px" }}>Cloud Scanner</span>
              </Dropdown.Item>
              <Dropdown.Item as={Link} to="/pull-request-helper">
                <span style={{ marginRight: "5px" }}>Pull Request Helper</span>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <Dropdown
            onToggle={handleSolutionsToggle}
            className="jigsaw_nav_item jigsaw_scanner"
          >
            <Dropdown.Toggle
              style={{
                background: "transparent",
                border: "none",
                padding: "0",
                color: "#B1B1B1",
              }}
            >
              <span>
                <span style={{ marginRight: "5px" }}>Solutions</span>
                {isSolutionsDropdownOpen ? (
                  <ChevronUp className="chevron-icon" />
                ) : (
                  <ChevronDown className="chevron-icon" />
                )}
              </span>
            </Dropdown.Toggle>

            <Dropdown.Menu
              style={{ border: "none", marginLeft: "40px" }}
              className="jigsaw_nav_item"
            >
              <Dropdown.Item as={Link} to="/governance">
                <span style={{ marginRight: "5px" }}>Governance</span>
              </Dropdown.Item>
              <Dropdown.Item as={Link} to="/ai-code-review">
                <span style={{ marginRight: "5px" }}>AI Code Review</span>
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          {/* Disabling blogs until we move them to the newer theme:
              <Link
                  to={"/blog"}
                  className="jigsaw_nav_item"
              >
                  Blogs
              </Link> */}
          <Link
            to={"/open-source-projects"}
            className="jigsaw_nav_item jigsaw_scanner"
          >
            <span>Open-Source</span>
          </Link>
          <Link to="/pricing" className="jigsaw_nav_item jigsaw_scanner">
            <span>Pricing</span>
          </Link>
          <Dropdown
            onToggle={handlePressToggle}
            className="jigsaw_nav_item jigsaw_scanner jigsaw_press_dropdown"
          >
            <Dropdown.Toggle
              style={{
                background: "transparent",
                border: "none",
                padding: "0",
                color: "#B1B1B1",
              }}
            >
              <span>
                <span style={{ marginRight: "5px" }}>Insights</span>
                {isPressDropdownOpen ? (
                  <ChevronUp className="chevron-icon" />
                ) : (
                  <ChevronDown className="chevron-icon" />
                )}
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu
              style={{ border: "none", marginLeft: "40px" }}
              className="jigsaw_nav_item"
            >
              <Dropdown.Item
                as="a"
                href="https://blog.jigsawml.com/"
                target="_self"
              >
                Blogs
              </Dropdown.Item>
              <Dropdown.Item as={Link} to="/in-press">
                In Press
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        {/* )} */}

        {/* Buttons in separate container - Desktop */}
        {/* {!isChangePasswordPage && ( */}
        <div className="jigsaw_button_container jigsaw_desktop_buttons">
          {!isLoggedIn && (
            <a
              href={CALENDLY_TALK_TO_US_URL}
              className="jigsaw_talk_button"
              target="_blank"
              rel="noopener noreferrer"
            >
              Talk to us
            </a>
          )}
          {!isDemoPage && (
            <Link to={"/demo"} className="jigsaw_demo_button">
              See Demo
            </Link>
          )}
          {!isLoginPage && loginOrDashboardButton}
          {isLoggedIn && (
            <ProfileDropdown
              logoutHandler={resolvedLogout}
              className="mx-auto patch-dropdown"
              menuClassName="user-dropdown-toggle"
              avatarClassName="user-img"
              drop="down"
            />
          )}

          {/* {allowBeta && (
              <button
                className="joinButton"
                type="button"
                onClick={() => {
                  setEmail("");
                  setName("");
                  setAffiliation("");
                  setMessage("");
                  setIsValidEmail(null);
                  setEmailError("");
                  setShowAccessModal(true);
                }}
              >
                Join Beta
              </button>
            )} */}
          {/* {isLoginPage && (
            <button className="jigsaw_demo_button" onClick={handleBackClick}>
              <ArrowBack />
              <span className="back-btn">Back</span>
            </button>
          )} */}
        </div>
        {/* )} */}

        {/* Mobile Menu Overlay */}
        {isMobileMenuOpen && (
          <div className="jigsaw_mobile_menu_overlay">
            <div className="jigsaw_mobile_nav_items">
              {/* <Link
                    to={"/product"}
                    className="jigsaw_nav_item jigsaw_scanner"
                >
                    <span>Software Scanner</span>
                    <span className="jigsaw_beta_tag">Beta</span>
                </Link> */}
              <Link to={"/"} className="jigsaw_nav_item jigsaw_scanner">
                <span>Home</span>
              </Link>
              <Dropdown
                onToggle={handleProductToggle}
                className="jigsaw_nav_item jigsaw_scanner"
              >
                <Dropdown.Toggle
                  style={{
                    background: "transparent",
                    border: "none",
                    padding: "0",
                    color: "#B1B1B1",
                  }}
                >
                  <span>
                    <span style={{ marginRight: "5px" }}>Product</span>
                    {isProductDropdownOpen ? (
                      <ChevronUp className="chevron-icon" />
                    ) : (
                      <ChevronDown className="chevron-icon" />
                    )}
                  </span>
                </Dropdown.Toggle>

                <Dropdown.Menu
                  style={{ border: "none", marginLeft: "40px" }}
                  className="jigsaw_nav_item"
                >
                  <Dropdown.Item as={Link} to="/product">
                    <span style={{ marginRight: "5px" }}>
                      Architecture Generator
                    </span>
                    {/* <span className="jigsaw_beta_tag">Beta</span> */}
                  </Dropdown.Item>
                  <Dropdown.Item as={Link} to="/cloud-scanner">
                    <span style={{ marginRight: "5px" }}>Cloud Scanner</span>
                    {/* <span className="jigsaw_beta_tag">Free trial</span> */}
                  </Dropdown.Item>
                  <Dropdown.Item as={Link} to="/pull-request-helper">
                    <span style={{ marginRight: "5px" }}>Pull Request Helper</span>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown
                onToggle={handleSolutionsToggle}
                className="jigsaw_nav_item jigsaw_scanner"
              >
                <Dropdown.Toggle
                  style={{
                    background: "transparent",
                    border: "none",
                    padding: "0",
                    color: "#B1B1B1",
                  }}
                >
                  <span>
                    <span style={{ marginRight: "5px" }}>Solutions</span>
                    {isSolutionsDropdownOpen ? (
                      <ChevronUp className="chevron-icon" />
                    ) : (
                      <ChevronDown className="chevron-icon" />
                    )}
                  </span>
                </Dropdown.Toggle>

                <Dropdown.Menu
                  style={{ border: "none", marginLeft: "40px" }}
                  className="jigsaw_nav_item"
                >
                  <Dropdown.Item as={Link} to="/governance">
                    <span style={{ marginRight: "5px" }}>Governance</span>
                  </Dropdown.Item>
                  <Dropdown.Item as={Link} to="/ai-code-review">
                    <span style={{ marginRight: "5px" }}>AI Code Review</span>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <Link
                to={"/open-source-projects"}
                className="jigsaw_nav_item jigsaw_scanner"
              >
                <span>Open-Source</span>
              </Link>
              <Link to="/pricing" className="jigsaw_nav_item jigsaw_scanner">
                <span>Pricing</span>
              </Link>
              {/* <Link
                    to={"/blog"}
                    className="jigsaw_nav_item"
                >
                    Blogs
                </Link> */}
              <Dropdown
                onToggle={handlePressToggle}
                className="jigsaw_nav_item jigsaw_scanner jigsaw_press_dropdown"
              >
                <Dropdown.Toggle
                  style={{
                    background: "transparent",
                    border: "none",
                    padding: "0",
                    color: "#B1B1B1",
                  }}
                >
                  <span>
                    <span style={{ marginRight: "5px" }}>Insights</span>
                    {isPressDropdownOpen ? (
                      <ChevronUp className="chevron-icon" />
                    ) : (
                      <ChevronDown className="chevron-icon" />
                    )}
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  style={{ border: "none", marginLeft: "40px" }}
                  className="jigsaw_nav_item"
                >
                  <Dropdown.Item
                    as="a"
                    href="https://blog.jigsawml.com/"
                    target="_self"
                  >
                    Blogs
                  </Dropdown.Item>
                  <Dropdown.Item as={Link} to="/in-press">
                    In-Press
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <div className="jigsaw_mobile_buttons">
                {!isLoggedIn && (
                  <a
                    href={CALENDLY_TALK_TO_US_URL}
                    className="jigsaw_talk_button"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Talk to us
                  </a>
                )}
                <Link
                  to={"/demo"}
                  className="jigsaw_demo_button"
                  style={{ visibility: isDemoPage ? "hidden" : "visible" }}
                >
                  See Demo
                </Link>
                {loginOrDashboardButton}
                {/* {allowBeta && (
                  <button
                    className="jigsaw_login_button"
                    type="button"
                    onClick={() => {
                      setEmail("");
                      setName("");
                      setAffiliation("");
                      setMessage("");
                      setIsValidEmail(null);
                      setEmailError("");
                      setShowAccessModal(true);
                    }}
                  >
                    Join Beta
                  </button>
                )} */}
              </div>
            </div>
          </div>
        )}
      </div>
      <AccessModal
        show={showAccessModal}
        handleClose={() => setShowAccessModal(false)}
        formRef={formRef}
        name={name}
        affiliation={affiliation}
        message={message}
        email={email}
        isValidEmail={isValidEmail}
        emailError={emailError}
        isSubmitting={isSubmitting}
        setNameHandler={setNameHandler}
        setAffiliationHandler={setAffiliationHandler}
        setMessageHandler={setMessageHandler}
        setEmailHandler={setEmailHandler}
        formSubmitHandler={formSubmitHandler}
      />
      <ThanksModal
        show={showThanksModal}
        handleClose={() => setShowThanksModal(false)}
      />
    </nav>
  );
};

export default Navbar;
